import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
import { InventoryService } from './inventory.service';
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { locateHostElement } from '@angular/core/src/render3/instructions';
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
  selector: 'Part-Master',
  templateUrl: './partMaster.component.html'
})
export class PartMasterComponent {
  public distinctCat: any[];
  public distinctSubCat: any[];
  public distinctPartType: any[];
  public distinctUOM: any[];
  search: any;
  prjId: any;
  showLoader: boolean;
  vehMaintMasterList: any;
  vehMaintUOMList: any;
  priceModal: any;
  uomModal: any;
  serviceModal: any;
  partModal: any;
  quantityModal: any;
  upQuantityModal: any;
  saveSuccess = false;
  errorInSuccess = false;
  userId: any;
  respMsg: any;
  selectedRow: number;
  maintMstDataNotFound = false;
  vehiclesCatogeryList: any;
  vehiclesTypeList: any;
  vehCotegaryId: any;
  vehTypeId: any;
  partCode: any;
  imgLoaderPath: any;
  entityCodeLoaderDiv = false;
  isVehicleUpdtbtn = false;
  newPartCode: any;
  isBtnSave = false;
  categoryList: any;
  subCategoryList: any;
  partTypeList: any;

  partNameList:any;
  vanderList:any;

  dateRangeModal: any

  categoryId: any;
  partModalData: any;
  typeModal: any;
  categoryModal: any;
  subCategoryModal: any;
  newCategory: any;
  categoryCreateMsg: any;
  categorySuccess = false;
  categoryError = false;
  newVendor: any;

  newSubCategory:any;

  newvendorName :any;
  subCatError = false;
  subCatSuccess = false;
  newPartTypeModal: any;
  partSuccess = false;
  partError = false;
  itemToUpdate: any;
  upCategoryModal: any;
  upTypeModal: any;
  upPartModal: any;
  upUomModal: any;
  upPriceModal: any;
  upSubCategoryModal: any;
  CATNAME: string;
  partCodeModal: any;
  syncing: any;
  public roleList: any;
  loaderClass: any;
  vTypeModel: any;
  vSubCategoryModal: any;
  vCategoryModal: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  newQuantityModal: any;
  newPriceModal: any;
  public wrongQuantity: boolean = false;
  vendorModal: any;
  invoiceModal: any;
  inwardModal: any;
  invoiceDateModal: any;
  userName: string;
  PARTNAME: any;
  ENTRYDATE: any;
  ENTRYBY: any;
  vendorId: any;
  startDate: string;
  endDate: typeof _moment;
  updateStock: { id: number; name: string; }[];
  public one = false ;
  public two = false ;
  vVenderName: any;
  U_Invoice: any;
  updateStockValue: any;
  partsDetailsList: Object;
  partsHistoryList: Object;
  totalPrice: any;
  todayusedPrice: any;
  ZeroStock: any;
  todayUsedStock: any;
  remaingStock: any;
  defaultStartDate: string;
  defaultEndDate: string;
  selectedBillType: any;
  challanNumber: any;
  newBillNumber: any;
  newBillNumberCheck: boolean;
  ChallanvalueCheck: boolean;
  selectedBillTypeCheck: boolean;
  NewChallanmodal: any;
  challanOrInvoice: any;
  newChallan: any;
  partId: any;
  partMasterId: any;
  mainPartId: any;
  tsStartdate: string;
  tsEndDate: string;
  TsTotalAmount: any;
  TsTotalParts: any;
  purchaseType: any;
  cashCreditModal: any;

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  vUomModel: any;
  selectedCatID: any;
  selectedSubCatID: any;
  selectedUomID: any;
  selectedTypemID: any;
  oneCatID: any;
  oneSubCatID: any;
  oneUomID: any;
  oneTypeID: any;
  newSubCategoryList: any;
 

  private loadProducts(): void {
    this.gridinventory = process(this.vehMaintMasterList, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    public _inventory: InventoryService,
    
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    var date = new Date();
    this.selectedBillType = '';
    this.selectedBillTypeCheck = false;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
   
    this.dateRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };



   this.purchaseType = [
      { id: 2, name: 'Cash' },
      { id: 1, name: 'Credit' } 
  ];








  }

	/*
   * Get All Vehicle Master List
  */

  getMaintMasterList() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'maintenance/getMaintenanceMaster?prjid=' + this.prjId).subscribe((data) => {
      this.vehMaintMasterList = data;
      
      if (this.vehMaintMasterList.length > 0) {
        this.gridinventory = process(this.vehMaintMasterList, this.state);
        this.distinctCat = distinctCat(this.vehMaintMasterList);
        this.distinctSubCat = distinctSubCat(this.vehMaintMasterList);
        this.distinctPartType = distinctPartType(this.vehMaintMasterList);
        this.distinctUOM = distinctUOM(this.vehMaintMasterList);
        this.maintMstDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.maintMstDataNotFound = true;
        this.loaderService.display(false);
        this.gridinventory = process(this.vehMaintMasterList, this.state);
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.vehMaintMasterList, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.vehMaintMasterList, this.state);
    }
  }

	/*
 *OPEN Maintenance Modal  
 */
  AddVehiclePartModal() {
    this.clearAllFields();
    $('#vehMaintMasterModal').modal('show', null);
  }

	/*
 *Open Update Inventory Modal  
 */
  UpdateVehiclePartModal(vehMaintMasterList) {
    $('#vehMaintMasterModal').modal('show', vehMaintMasterList);
  }

	/*
 *Get Vehicle Service Type 
 */
  // getVehicleServiceType(){
  //   this.http.get(environment.apiUrl+'maintenance/getVehServiceType').subscribe(data =>{
  //     this.vehMaintServiceList=data;
  //   });
  // }

	/*
 * Update Vehicle Details Opem Modal popup
 */
  updateInventory(data) {
    

     console.log('288',data);
     


    $('#updateModal').modal('show'); 


    this.updateStockValue = null;
    this.one = false
    this.two = false 
    this.isVehicleUpdtbtn = false;


    this.vVenderName  =  data.vendorName
    this.vCategoryModal = data.CATNAME;
    this.vSubCategoryModal = data.SUBCATNAME;
    this.vTypeModel = data.PARTTYPENAME;
    this.partModal = data.PARTNAME;
    this.partCodeModal = data.PARTID;
    this.ENTRYDATE = data.ENTRYDATE;
    this.ENTRYBY = data.USERID;
    this.priceModal = data.UNITPRICE;
    this.quantityModal = data.availableQuantity;
    this.vUomModel = data.UOMTYPENAME

    this.mainPartId = data.MaintenancePartListID

    this.selectedCatID = this.categoryList.filter(
      (item) => item.CATNAME == this.vCategoryModal
    );
  
    this.getCatID(this.selectedCatID)


    this.selectedUomID = this.vehMaintUOMList.filter(
      (item) => item.UOMTYPENAME == this.vUomModel
    );
  
    this.getUomID(this.selectedUomID)


    this.selectedTypemID = this.partTypeList.filter(
      (item) => item.PARTTYPENAME == this.vTypeModel
    );
  
    this.getTypeID(this.selectedTypemID)
  }

  getCatID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneCatID = data[i].ID

      this.http
        .get(environment.apiUrl + 'maintenance/getSubCategoryList?catId=' + data[i].ID)
        .subscribe((data) => {
          this.newSubCategoryList = data;
          // console.log("New sub", this.newSubCategoryList)

          this.selectedSubCatID = this.newSubCategoryList.filter(
            (item) => item.SUBCATNAME == this.vSubCategoryModal
          );
          // console.log("Type", this.selectedSubCatID)
          this.getSubCatID(this.selectedSubCatID)

        });
    }
   
  }

  getSubCatID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneSubCatID = data[i].ID
    }
   
  }

  getUomID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneUomID = data[i].ID
    }
   
    
  }

  getTypeID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneTypeID = data[i].ID
    }
   
    
  }

	/*
 *Get UOM Type 
 */
  getVehicleUOMType() {
    this.http.get(environment.apiUrl + 'maintenance/getVehUOMType').subscribe((data) => {
      this.vehMaintUOMList = data;
    });
  }

  onSelectServiTypece(data) { }

  onSelectUOMType(data) { }

	/*
 *Save maintenance Master Data
 */

//  get past master id 

getPartId(partMasterId){
  this.partMasterId = partMasterId.id
}


  saveMaintenanceMaster() {
    

 


    
    if (this.cashCreditModal == null) {
      alert('Purcahse Type is Required!');
      this.isBtnSave = true;
      return;
    }else if (this.categoryModal == null) {
      alert('Category is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.subCategoryModal == null) {
      alert('SubCategory is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.typeModal == null) {
      alert('Type is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.partModal == null) {
      alert('Part Name is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.quantityModal == null) {
      alert('Quantity is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.uomModal == null) {
      alert('UOM Type is Required!');
      this.isBtnSave = true;
      return;
    }
    else if (this.priceModal == null || this.priceModal == 0) {
      alert('Price is Required with values!')
      this.isBtnSave = true;
      return;
    }

       if(!this.selectedBillType){

          alert('bill type is Required!');
          this.isBtnSave = true;
            return;
      }

       if(!this.invoiceModal){

        alert('invoice number is Required!');
             this.isBtnSave = true;
          return;
         }
 



         var yearsstring = moment().format('YYYY');
         var monthsstring = moment().format('MM');


    var hhmmss = moment().format('HHMMSS');


      
   



    var data = {
      prjid: this.prjId,
      partName: this.partModal.trim(),
      quantity: this.quantityModal,
      cateId: this.categoryModal,
      subCatId: this.subCategoryModal,
      typeId: this.typeModal,
      UomTypeId: this.uomModal,
      price: this.priceModal,
      userId: this.userId,
      vendorName: this.vendorModal,
      vendorId: this.vendorId,
      invoiceNumber: 'INV-'+yearsstring+monthsstring+hhmmss+'-'+this.invoiceModal,//  INV-2022091449-22-79
      invoiceDate: this.invoiceDateModal,
      inwardDate: this.inwardModal,
      billType:this.selectedBillType,
      newChallan:this.newChallan,
      partListId:this.partMasterId,
      cashCredit:this.cashCreditModal
      //challanumber :this.NewChallanmodal
    };
    this.isBtnSave = true;
   

     console.log('467',data);
     



    this.http.post(environment.apiUrl + 'maintenance/saveVehicleMaintMaster', data).subscribe(
      (data) => {

    
        var result: any;
        result = data;
       
        var resCode = result.status[0].RESPONSECODE;
        if (resCode == 200) {
          this.saveSuccess = true;
          this.respMsg = result.status[1].RESPONSEMESSAGE;
          this.newPartCode = result.status[2].IDRESPONSE;
          this.getMaintMasterList();
          setTimeout(() => {
            this.saveSuccess = false;
            $('#vehMaintMasterModal').modal('hide');
            this.isBtnSave = false;
            this.updateHistory('insert')
          }, 2000);
          this.loaderService.display(false);
        } else {
          this.saveSuccess = false;
          this.errorInSuccess = true;
          this.loaderService.display(false);
          this.isBtnSave = false;
        }
      },
      (error) => {
        this.loaderService.display(false);
        this.isBtnSave = false;
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again'
        });
      }
    );


  }




  /*
 * Delete a part
 */
  deleteModalPopup(item) {


  


   var partID = item.PARTID;


         console.log('528',partID);
         
          

    Swal({
      title: 'Are you sure to delete this part?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then((result) => {
      if (result.value) {
        this.http.get(environment.apiUrl + 'maintenance/deletePart?partId=' + partID+'&PRJID='+this.prjId).subscribe((data) => {
          var respStatus: any;
          respStatus = data;
      

          if (!this.vehMaintMasterList.PARTID) {
            this.getMaintMasterList();
            $('#partItemModal').modal('hide');
            Swal('Part deleted successfully.', 'success');
          } else {
            Swal('Error during part deletion.', 'error');
            this.syncData();
          }
        });
      }
    });




  }

  syncData() {
    this.syncing = true;
    this.loaderClass = 'fas fa-sync fa-spin';
    this.http.get(environment.apiUrl + 'maintenance/getMaintenanceMaster?prjid=' + this.prjId).subscribe((data) => {
      this.syncing = false;
      this.loaderClass = 'fas fa-sync';
      this.getMaintMasterList();
    });
   
  }

	/*
  Update Part Master
*/
  onClickToUpdateInventory() {

    



    this.U_Invoice 


    if (this.U_Invoice  == null) {
      alert('New Invoce  is Required!');
      this.isBtnSave = true;
      return;
    }else if (this.newQuantityModal == null) {
      alert('Quantity is Required!')
      this.isBtnSave = true;
      return;
    }
    var data = {
      prjid: this.prjId,
      catId: this.oneCatID,
      subCatId: this.oneSubCatID,
      typeId: this.oneTypeID,
      partId: this.partCodeModal,
      uomId: this.oneUomID,
      quantity: this.newQuantityModal ? this.newQuantityModal : 0,
      unitPrice: this.newPriceModal,
      price: this.priceModal,
      invoiceNumber :this.U_Invoice  ,
      partListId:this.mainPartId,
      billType:this.selectedBillType,
      vendorName:this.vVenderName,
      cashCredit:this.cashCreditModal

    }


  



    
    
  this.http.post(environment.apiUrl + 'maintenance/updatePartMaster', data).subscribe((data) => {
      var code: any;
      code = data;
      this.syncData();
      this.clearAllFields()
      this.getMaintMasterList();
      Swal('Quantity has been updated successfully.', 'success');
    });
    this.updateHistory('update');
}

  updateHistory(entryType){
    var date = moment(new Date()).format('YYYY-MM-DD hh:mm:ss');
    this.newPriceModal = (this.newPriceModal == '' || this.newPriceModal == undefined || this.newPriceModal == null) ? this.priceModal : this.newPriceModal
    this.newQuantityModal = (this.newQuantityModal == '' || this.newQuantityModal == undefined || this.newQuantityModal == null) ? this.quantityModal : this.newQuantityModal
    var parObj = {
      prjid: this.prjId,
      partid: entryType == 'update' ? this.partCodeModal : this.newPartCode,
      partname: this.partModal,
      unitprice: entryType == 'update' ? this.newPriceModal : this.priceModal,
      qty: entryType == 'update' ? this.newQuantityModal : this.quantityModal,
      entryDate: entryType == 'update' ? this.ENTRYDATE : date,
      updateDate: entryType == 'update' ? date : '',
      entryBy: entryType == 'update' ? this.ENTRYBY : this.userName,
      updatedBy: entryType == 'update' ? this.userName : ''
    }

    var obj = {
      partID : parObj.partid,
      date : date,
      data : parObj
    }
    this._inventory.addInventoryHistory(obj);
  }

  clearAllFields() {
    this.categoryModal = null;
    this.partModal = null;
    this.quantityModal = null;
    this.subCategoryModal = null;
    this.typeModal = null;
    this.uomModal = null;
    this.priceModal = null;
    this.newBillNumber= null;
    this.selectedBillType = null ;
    this.NewChallanmodal  = null;
    this.challanOrInvoice = null;
    this.selectedBillTypeCheck = false;

    this.newBillNumberCheck = false;
    
    this.oneCatID=null;
     this.oneSubCatID=null;
     this.oneTypeID=null;
    this.partCodeModal=null;
    this.oneUomID=null;
    this.newQuantityModal = null ;
    this.newPriceModal=null;
    this.priceModal=null;
   this.U_Invoice  =null;
   this.mainPartId=null;
   this.selectedBillType= null ;


   
  }

  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return true;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  downloadExcelFile(vehicleInfoData,filename) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), filename);
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

	/*
    * TO GET VEHICLE CATEGORY LIST
    */

  getAllVehiclesCategory() {
    this.http.get(environment.apiUrl + 'admin/getVehiclesCatogeryType').subscribe((data) => {
      this.vehiclesCatogeryList = data;
    });
  }

	/*
     *TO GET VEHICLE TYPE LIST BY CATEGORY SELECTION
    */

  onChangeVehCategory(data) {
    this.getAllVehiclesType(data.ID);
  }

	/*
     *TO GET VEHICLE TYPE LIST BY CATEGORY ID
    */

  getAllVehiclesType(catId) {
    this.http.get(environment.apiUrl + 'admin/getVehiclesType?catId=' + catId).subscribe((data) => {
      this.vehiclesTypeList = data;
    });
  }

	/*
  * Get Part Category Data
  */
  getPartCategory() {
    this.http.get(environment.apiUrl + 'maintenance/getPartCategoryList').subscribe((data) => {
      this.categoryList = data;
    });
  }
	/*
  * Get Type Details By Cat Id
  */
  onChangeCategory(data) {
   
    this.categoryId = data.ID;
    this.http
      .get(environment.apiUrl + 'maintenance/getSubCategoryList?catId=' + this.categoryId)
      .subscribe((data) => {
        this.subCategoryList = data;
      });
  }

	/*
  * Get Part Category Data
  */
  getPartTypeList() {
    this.http.get(environment.apiUrl + 'maintenance/getPartTypeList').subscribe((data) => {
      this.partTypeList = data;
    });
  }

  getPartNameList() {
    this.http.get(environment.apiUrl + 'maintenance/getPartNameList').subscribe((data) => {
      this.partNameList = data;

    
      
    });
  }

  
  getVanderNameList() {
    this.http.get(environment.apiUrl + 'maintenance/getvanderList').subscribe((data) => {
      this.vanderList = data;

       
    });
  }


  createCategory() {
    $('#createCategory').modal('show');
  }

  saveCategory() {
    if (this.newCategory == null) {
      alert('Category is Required!');
      return;
    }
    var data = {
      category: this.newCategory,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createCategory', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.categorySuccess = true;
        this.getMaintMasterList();
        this.getPartCategory();
        this.newCategory = null;
        setTimeout(() => {
          $('#createCategory').modal('hide');
          this.categorySuccess = false;
        }, 2000);
      } else {
        this.categoryError = true;
      }
    });
  }

  createSubCategory() {
    $('#createSubCategory').modal('show');
  }

  saveSubCategory() {
    if (this.newSubCategory == null) {
      alert('SubCategory is Required!');
      return;
    }
    var data = {
      subCategory: this.newSubCategory,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createSubCategory', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.subCatSuccess = true;
        this.getMaintMasterList();
        this.newSubCategory = null;
        setTimeout(() => {
          $('#createSubCategory').modal('hide');
          this.subCatSuccess = false;
        }, 2000);
      } else {
        this.subCatError = true;
      }
    });
  }


// saveVendorMaster()
   

saveVendorMaster(){

  if (this.newvendorName == null) {
    alert('SubCategory is Required!');
    return;
  }
  var data = {
    newvendorName: this.newvendorName,
    prjId: this.prjId
  };
  this.http.post(environment.apiUrl + 'maintenance/saveNewVendor', data).subscribe((data) => {
    var code: any;
    code = data;
    if (code.status == 'ok') {
      this.subCatSuccess = true;
      this.getMaintMasterList();
      this.newSubCategory = null;
      setTimeout(() => {
        $('#newVendor').modal('hide');
        this.subCatSuccess = false;
      }, 2000);
    } else {
      this.subCatError = true;
    }
  });





}










  createNewPart() {
    $('#createPartType').modal('show');
  }

  savePartType() {
    if (this.newPartTypeModal == null) {
      alert('Part type is required!');
      return;
    }
    var data = {
      partType: this.newPartTypeModal,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createPartTypeData', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.partSuccess = true;
        this.getMaintMasterList();
        this.getPartTypeList();
        
        this.newPartTypeModal = null;
        setTimeout(() => {
          $('#createPartType').modal('hide');
          this.partSuccess = false;
        }, 2000);
      } else {
        this.partError = true;
      }
    });
  }

  ngOnInit() {

    this.prjId = this.auth.getAuthentication().projectId;
  
    

    this.userId = this.auth.getAuthentication().id;
    this.userName = this.auth.getAuthentication().userName;
    this.getMaintMasterList();
    this.getVehicleUOMType();
    //this.getAllVehiclesCategory();
    this.getPartCategory();
    this.getPartTypeList();
    this.getPartNameList();
    this.getVanderNameList();


     this.getTodayUsedStock();
     this.getRemainingStock();
     this.getTotalStock();
     this.getRemainingPrice();
     this.getTodayUsedPrice();


     this.gettodayusedpartAndAmountTrsnferStationData();

 
    this.invoiceDateModal = moment().format('YYYY-MM-DD');
    this.inwardModal = moment().format('YYYY-MM-DD');



    this.updateStock = [
      { id: 1, name: 'Same Vendor and Same Prize' },
      { id: 2, name: 'Same Vendor and New Prize' },
      { id: 3, name: 'New Vendor' }
     
  ];
  }





  getVanderName(event){

    this.vendorModal = event.vendorName;


   
           
  }


  openNewVendorForm(){
    $('#vehMaintMasterModal').modal('hide');
    $('#newVendor').modal('show');
  }

  updateStockChange(event){

             if(event.id == 1){

                this.one = true
                this.two = false 
             }else if(event.id == 2 || event.id == 3){
                  this.one = false
                  this.two = true 
                  $('#updateModal').modal('hide');

                  $('#vehMaintMasterModal').modal('show');
                 




             }

  }


  partItemModal(dataPart){


    console.log('1056',dataPart);
    


    var partid = dataPart.MaintenancePartListID



    this.http.get(environment.apiUrl + 'maintenance/PartDetailsList?partid='+partid).subscribe((data) => {
     this.partsDetailsList = data ;
     
     

    });

    this.http.get(environment.apiUrl + 'maintenance/PartDetailsHisroryList?partid='+partid).subscribe((data) => {
      this.partsHistoryList = data ;

      
      

     });
     
    

    $('#partItemModal').modal('show');
                 

  }



  getTodayUsedStock(){
   	var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

		this.http.get(environment.apiUrl + 'maintenance/getTodayUsedStock?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
			
			let result = res;


         //console.log('1050',result)



        // console.log('1054',result['totalparts'])
         //console.log('1054',result['Tsparts'])


        //  totalAmount

         //console.log('1060',result['Tsparts'][0]['totalAmount'])



          // var qty = JSON.parse(result['Tsparts'][0]['json_part_array'])

        //  console.log('1063',JSON.parse(result['Tsparts'][0]['json_part_array']));

        // console.log(qty[0]['quantity']);


        //   var tspartcount = 0;
        //   var tspartamount = 0;

        //  for (let index = 0; index < result['Tsparts'].length; index++) {


        //     var    qtys =JSON.parse(result['Tsparts'][index]['json_part_array']).length;
        //     tspartamount +=Number(result['Tsparts'][index]['totalAmount']);

        //     for (let i = 0; i < qtys.length; i++) {

        //       console.log('here');
              
        //       const qty = qtys[i]['quantity'];
        //       tspartcount+=qty
        //     }



        //  }


        // console.log('tspartcount',tspartcount,tspartamount);
         
      this.todayUsedStock = result[0]['todayusedStock']

			//this.totalPrice = result[0]['price']
      //this.remaingStock = result[1][0]['remaingStock']
      //this.todayUsedStock = result[0]['todayusedStock']
      //this.todayusedPrice = result[3][0]['amountToday'],
     // this.ZeroStock = result[4][0]['zeroStock'],

 		});

	 }



   getRemainingStock(){
    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

   this.http.get(environment.apiUrl + 'maintenance/getRemainingStock?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
     
     let result = res;

    
     
     this.remaingStock = result[0]['remaingStock']

   


    });

  }

  changechallanOrInvoice(event){

    this.newBillNumberCheck = false
     this.selectedBillType = event.target.value;

     this.newBillNumber = '';

     this.invoiceModal = '';

     this.selectedBillTypeCheck = true ;
      
     this.getChallanNuber();

     /*
        bill type: Chal + Invc
             Have to show drop down in both case

        
     
     
     */ 
  }

  getTodayUsedPrice(){

    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

   
    

   this.http.get(environment.apiUrl + 'maintenance/getTodayUsedPrice?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
     
     var result = res;

   
    
     this.todayusedPrice = result[0]['amountToday']


    });

  }



  

  getRemainingPrice(){
    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

   this.http.get(environment.apiUrl + 'maintenance/getRemainingPrice?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
     
     let result = res;
     this.totalPrice = result[0]['price']


    });

  }


  getTotalStock(){
    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

   this.http.get(environment.apiUrl + 'maintenance/getTotalStock?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
        var result: any;
          result = res;
      this.ZeroStock =result

     
      

    


    });

  }
  getTotalStockClick(){
    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

   this.http.get(environment.apiUrl + 'maintenance/getTotalStock?prjid=' + this.prjId + '&date='+QytPSDate).subscribe(res => { 
     

     this.downloadExcelFile(res,'ZeroParts.xlsx')
    


    });

  }



  PurchaseReport(){
    var QytPSDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

    let fromDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let toDate = moment(this.defaultEndDate).format('YYYY-MM-DD');

   this.http.get(environment.apiUrl + 'maintenance/PurchaseReport?prjid=' + this.prjId + '&fromDate='+fromDate+'&toDate='+toDate).subscribe(res => { 
     

     this.downloadExcelFile(res,'PurchaseReport.xlsx')
    


    });

  }
  
  


  DownLoadSparePartsReport(){
      


    

    this.http.get(environment.apiUrl + 'maintenance/DownLoadSparePartsReport?prjId=' + this.prjId).subscribe((data) => {

   
      
            
      this.downloadExcelFile(data,'SpareParts.xlsx')
    
    });


  }


  usedPartReort(){
       
   
    
    this.http.get(environment.apiUrl + 'maintenance/usedPartReort?prjId=' + this.prjId).subscribe((data) => {
      
       
         
      this.downloadExcelFile(data,'USEDPARTSREPORTS.xlsx')
    
    });
   
    
  }


  AllReports(){

    $('#AllReportsModal').modal('show');

  }



  onDateRangeChanged(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
       this.DateWiseusedPartReort()
      // this.getTopPerformer()
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      this.DateWiseusedPartReort()
     
    }

  }





  onTSDateRangeChanged(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
       this.getPartDetaislTrsnferStationData()
      // this.getTopPerformer()
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      this.getPartDetaislTrsnferStationData()
     
    }



  }



  DateWiseusedPartReort(){
         
    console.log('1314',this.defaultStartDate,this.defaultEndDate)
    



    let fromDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let toDate = moment(this.defaultEndDate).format('YYYY-MM-DD');





     this.http.get(environment.apiUrl + 'maintenance/DateWiseusedPartReort?prjId=' + this.prjId+'&fromDt=' +
    fromDate +
    '&toDt=' +
    toDate).subscribe( (data) => {
      

      
   this.downloadExcelFile(data,'USEDPARTSREPORTS.xlsx')
 
    }
  );

    

    
  }



  getChallanNuber(){

    this.http.get(environment.apiUrl + 'maintenance/getChallanNuber?prjId=' + this.prjId+"&billType="+this.selectedBillType).subscribe( (data) => {

             
               
      
               this.challanNumber =  data
               this.challanNumber.unshift({
            'invoiceNumber':'New'
          })
      }

    );

  }


  challanChange(data){




  this.newBillNumberCheck = false
  this.newChallan = ''

    this.newBillNumber =  data['invoiceNumber']

    

    if( this.newBillNumber  == 'New'){
      this.invoiceModal = '';
      this.U_Invoice = '';
      this.newBillNumberCheck = true
      this.selectedBillTypeCheck = false
      this.newChallan = this.newBillNumber // 'New'
    }
     
 
  }



// 
 
// updatechangechallanOrInvoice(event){
  


//   this.newBillNumberCheck = false
//   this.selectedBillType = event.target.value;

//   this.newBillNumber = '';

//   this.invoiceModal = '';

//   this.selectedBillTypeCheck = true ;
   
//   this.getChallanNuber();



// // 

// }


      getPartDetaislTrsnferStationData(){
         this.tsStartdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.tsEndDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.loaderService.display(true);
    
          this.http.get(environment.apiUrl + 'maintenance/getPartDetaislTrsnferStationData?prjId=' + this.prjId+"&startdate="+this.tsStartdate+"&tsEndDate="+this.tsEndDate).subscribe( (data) => {


              console.log('excell data',data);

              this.downloadExcelFile(data,'ts.xlsx')
              
              this.loaderService.display(false);
 
               }

          );
      }


      gettodayusedpartAndAmountTrsnferStationData(){



             
          this.http.get(environment.apiUrl + 'maintenance/gettodayusedpartAndAmountTrsnferStationData?prjId=' + this.prjId+"&startdate="+this.tsStartdate).subscribe( (data) => {


                        //console.log('total and amount ',data,data[0],data['totalAmount']);


                        this.TsTotalAmount = data['totalAmount']
                        this.TsTotalParts = data['totalQuantity']


                            console.log('this.TsTotalAmount',this.TsTotalAmount,'this.TsTotalParts',this.TsTotalParts);
                            
                        
                        



                }

          );


      }




}



// WEBPACK FOOTER //
// ./src/app/maintenance/part/partMaster/partMaster.component.ts